import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { getMsalInstance } from "./auth/msalInstance";
import { msalConfig } from "./auth/authConfig";
import { MsalProvider } from "@azure/msal-react";
import initializeGlobalFunctions from './utils/globalFunctions';
import { localConfig } from './config/localConfig';
import { loadRuntimeConfig } from './config/runtimeConfig';


initializeGlobalFunctions();

const root = ReactDOM.createRoot(document.getElementById("root"));

// Load runtime config before rendering the app
loadRuntimeConfig().then(() => {
	const msalInstance = getMsalInstance();
	// Conditionally wrap with MsalProvider based on local config
	console.log('msalInstance: ', msalInstance)
	if (localConfig.skipAuth) {
		// Local development mode - skip MSAL authentication
		root.render(
			<React.StrictMode>
				<App />
			</React.StrictMode>
		);
	} else {
		// Production mode - use MSAL authentication
		root.render(
			<React.StrictMode>
				<MsalProvider instance={msalInstance}>
					<App />
				</MsalProvider>
			</React.StrictMode>
		);
	}
});

reportWebVitals();
